import {
    IconButton,
    InputAdornment,
    TextField,
    Tooltip,
    withStyles,
  } from "@material-ui/core";
  import SearchIcon from "@material-ui/icons/Search";
  import CloseIcon from "@material-ui/icons/Close";
  
  const styles = () => ({
    /* Search input in the control panel */
    searchInput: {
      fontSize: 12,
      height: 30,
      fontFamily:'Sofia'
    }
  });
  function SearchInput({
    value,
    onCloseIconClick = () => {},
    onChange = () => {},
    classes,
    ...props
  }) {
    return (
      <TextField
        fontSize="small"
        variant="outlined"
        onChange={onChange}
        value={value}
        className={classes.searchBox}
        InputProps={{
          className: classes.searchInput,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Clear Search" placement="top" enterDelay={2000}>
                <IconButton
                  style={{ marginRight: "-16px" }}
                  onClick={onCloseIconClick}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
        placeholder="Search Here"
        {...props}
      />
    );
  }
  
  export default withStyles(styles)(SearchInput);
  